const announcements = {};

export default function addAnnouncement(chart) {
  const { name } = chart;
  if (name in announcements) {
    chart.announcement = announcements[name];
  }
  return chart;
}
